import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';

const StyledBackLink = styled(Link)`
  display: inline-block;
  margin: 0 0 1.4rem;
  font-size: 1.4rem;
  text-decoration: none;
  color: var(--c-black);
  transition: color 0.25s ease;
  @media (hover: hover) {
    &:hover {
      color: var(--c-red);
    }
  }
`;

const BackLink = props => {
  const { as, to, text, className } = props;
  return (
    <StyledBackLink as={as} className={className} to={to}>
      {text}
    </StyledBackLink>
  );
};

BackLink.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
};

export default BackLink;
